var _rect, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTask(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    rx: 6,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.8721 6.5H12.1221C11.5007 6.5 10.9971 7.00369 10.9971 7.625C10.9971 8.24632 11.5007 8.75 12.1221 8.75H15.8721C16.4934 8.75 16.9971 8.24632 16.9971 7.625C16.9971 7.00369 16.4934 6.5 15.8721 6.5Z",
    stroke: "black",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9971 16.25H13.5685M10.9971 13.25H16.9971",
    stroke: "black",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9971 7.625C18.1621 7.66011 18.8571 7.79006 19.3381 8.27103C19.9971 8.93004 19.9971 9.99068 19.9971 12.112V16.9996C19.9971 19.1209 19.9971 20.1816 19.3381 20.8406C18.679 21.4996 17.6184 21.4996 15.4971 21.4996H12.4971C10.3757 21.4996 9.31509 21.4996 8.65608 20.8406C7.99708 20.1816 7.99707 19.1209 7.99707 16.9996L7.99708 12.112C7.99707 9.99069 7.99707 8.93003 8.65608 8.27102C9.13704 7.79005 9.83195 7.66011 10.997 7.625",
    stroke: "black",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTask);
export default __webpack_public_path__ + "static/media/task.349d27c82e5e70821c3cc446d3eb073a.svg";
export { ForwardRef as ReactComponent };